import cn from 'classnames';
import { Dot, Tag } from 'sonata-react-components';

import './childItem.styles.scss';

import type { SidebarChildItemConfig } from './sidebar.types';

export function ChildItem({
  active,
  disabled,
  errorCount,
  dotStatus,
  icon,
  id,
  onSubsectionClick,
  text
}: Readonly<SidebarChildItemConfig>) {
  const getDotColor = () => {
    if (!dotStatus) {
      return undefined;
    }

    return dotStatus === 'success' ? 'var(--color-status-enabled-500)' : 'var(--color-status-warning-600)';
  };

  return (
    <div
      className={cn('childItem', { 'childItem--active': active, 'childItem--disabled': disabled })}
      onClick={() => !disabled && onSubsectionClick(id)}
      role="button"
      tabIndex={-1}
    >
      <div className="childItem__dot">{dotStatus && <Dot color={getDotColor()} label="" />}</div>
      {icon && (
        <div className="childItem__icon">
          <span className={cn('icon', icon)} />
        </div>
      )}
      <span className="childItem__text" title={text}>
        {text}
      </span>
      {Boolean(errorCount && errorCount > 0) && (
        <Tag className="childItem__errorBadge" id={`child-item-error-badge-${id}`} rounded status="wrong" tiny>
          {errorCount}
        </Tag>
      )}
    </div>
  );
}
